import { render } from "./CellPiece.vue?vue&type=template&id=cdd56ebe&scoped=true"
import script from "./CellPiece.vue?vue&type=script&lang=js"
export * from "./CellPiece.vue?vue&type=script&lang=js"

import "./CellPiece.vue?vue&type=style&index=0&id=cdd56ebe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-cdd56ebe"

export default script